import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LOCAL_STORAGE, localStorageFactory, LOCAL_STORAGE_STRICT, localStorageStrictFactory,
  SESSION_STORAGE, sessionStorageFactory, SESSION_STORAGE_STRICT, sessionStorageStrictFactory } from './storage/storage.provider';
import { WINDOW, windowFactory } from './window/window.provider';
import { CLIPBOARD, clipboardFactory } from './clipboard/clipboard.provider';


/**
 * A module that provides access to Window, LocalStorage, and SessionStorage.
 *
 * @see WINDOW
 * @see LOCAL_STORAGE
 * @see LOCAL_STORAGE_STRICT
 * @see SESSION_STORAGE
 * @see SESSION_STORAGE_STRICT
 * @see CLIPBOARD
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    { provide: WINDOW, useFactory: windowFactory },
    { provide: LOCAL_STORAGE, useFactory: localStorageFactory, deps: [WINDOW] },
    { provide: LOCAL_STORAGE_STRICT, useFactory: localStorageStrictFactory, deps: [WINDOW] },
    { provide: SESSION_STORAGE, useFactory: sessionStorageFactory, deps: [WINDOW] },
    { provide: SESSION_STORAGE_STRICT, useFactory: sessionStorageStrictFactory, deps: [WINDOW] },
    { provide: CLIPBOARD, useFactory: clipboardFactory, deps: [WINDOW] },
  ],
})
export class DomModule { }
